import axios, { type InternalAxiosRequestConfig } from 'axios';
import AuthService from '../Services/AuthService';
import { notify } from '../lib/notify';

export const axiosAzureInstance = axios.create();

// Collapse the burst of parallel requests a page mount fires into one refresh.
let tokenPromise: Promise<string | null> | null = null;

function getToken(): Promise<string | null> {
  if (!tokenPromise) {
    tokenPromise = AuthService.fetchNewAccessToken({ allowPopup: false }).finally(() => {
      tokenPromise = null;
    });
  }
  return tokenPromise;
}

let sessionExpiredHandled = false;

axiosAzureInstance.interceptors.request.use(async function (config: InternalAxiosRequestConfig) {
  const token = await getToken();
  if (!token) {
    if (!sessionExpiredHandled) {
      sessionExpiredHandled = true;
      notify.warning('Session expired', {
        description: 'Signing you out. Please sign in again to continue.',
        duration: 2000,
      });
      setTimeout(() => {
        AuthService.logout();
      }, 2000);
    }
    return Promise.reject(new Error('Session expired'));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
